import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const DayButton = styled(Box)(({ theme, selected }) => ({
  ...theme.typography.chipTitle,
  width: 46,
  height: 36,
  padding: theme.spacing(1, 1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '6px',
  cursor: 'pointer',
  backgroundColor: selected ? theme.colors.blue : theme.colors.softGray,
  color: selected ? theme.colors.white : theme.colors.blue,
  '&:hover': {
    backgroundColor: selected ? theme.colors.blue : theme.colors.softGray,
  },
  '&:active': {
    backgroundColor: selected ? theme.colors.blue : theme.colors.softGray,
  },
  transition: 'background-color 0.3s, color 0.3s',
}));

export const DaysContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  gap: theme.spacing(1),
  width: '100%',
}));
